// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HfX3","colMin":"styles_colMin__2vcxL"};